import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { TextField, Loadable } from "components/support";

class Filter extends Component {
  render() {
    const { filters, loading, onChange } = this.props;
    const { name, email, identification, phone } = filters;

    return (
      <Paper elevation={1} className="p-sm mb-md">
        <Loadable loading={loading}>
          <Typography type="headline">Filtro</Typography>
          <Row between="xs">
            <Col xs={12} sm={6} lg>
              <TextField
                allowClear
                fullWidth
                label="Nome"
                value={name}
                onChange={(_, value) => onChange("name", value)}
              />
            </Col>
            <Col xs={12} sm={6} lg>
              <TextField
                allowClear
                fullWidth
                label="E-mail"
                value={email}
                onChange={(_, value) => onChange("email", value)}
              />
            </Col>
            <Col xs={12} sm={6} lg>
              <TextField
                allowClear
                fullWidth
                label="Identificação"
                value={identification}
                onChange={(_, value) => onChange("identification", value)}
              />
            </Col>
            <Col xs={12} sm={6} lg>
              <TextField
                allowClear
                fullWidth
                label="Telefone"
                value={phone}
                onChange={(_, value) => onChange("phone", value)}
              />
            </Col>
          </Row>
        </Loadable>
      </Paper>
    );
  }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/filter/index.jsx